import React from 'react';
import styled from 'styled-components';

const MainHeader = () => {
  return <HeaderWrap></HeaderWrap>;
};

const HeaderWrap = styled.div`
  /* display: flex;
  width: 300px;
  height: 30px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background-color: lightblue; */
`;

const HeaderMenu = styled.div``;

export default MainHeader;
